import { SearchModelBase } from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class BTLocalDOListItem extends SearchModelBase {
    id: number = 0;
    u1ID: string = '';
    u2ID: string = '';
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    u1Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    status: string = '';
    closed: string = '';
    isClosed: boolean|null = null;

    doNo : string | null = null;
    doDate: string | null = null;
    carrier: string | null = null;
    pickupLoc: string | null = null;
    deliverTo: string | null = null;
    refNo: string | null = null;
    instruction: string | null = null;
    pickupDate: string | null = null;
    fromPickupDate: string | null = null;
    toPickupDate: string | null = null;
    fileClosed: boolean = false;
    orderNo: string | null = null;
    issuer: string | null = null;
    orderId: number = 0;
    orderCnt: number = 0;

    billStat: string = '';
    draft: boolean = false;
    trailerNo: string = '';
    

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Draft', width: 40, dataIndex: 'draft', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 2, text: 'D/O #', width: 110, dataIndex: 'doNo',defaultColumnFocus: true}),
        XCol.Create({ col: 3, text: 'Date', width: 100, dataIndex: 'doDate', type: XCol.XCellType.Date,lign: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Issuer', width: 140, dataIndex: 'issuer',  }),
        XCol.Create({ col: 5, text: 'Carrier', width: 130, dataIndex: 'carrier',  }),
        XCol.Create({ col: 6, text: 'Pickup Loc', width: 130, dataIndex: 'pickupLoc', }),
        XCol.Create({ col: 7, text: 'Deliver To', width: 130, dataIndex: 'deliverTo'}),
        XCol.Create({ col: 8, text: 'Ref. #', width: 110, dataIndex: 'refNo' }),
        XCol.Create({ col: 9, text: 'Trailer #', width: 110, dataIndex: 'trailerNo' }),
        XCol.Create({ col: 10, text: 'Instruction', width: 180, dataIndex: 'instruction'}),
        XCol.Create({ col: 11, text: 'Pickup Date', width: 100, dataIndex: 'pickupDate',type: XCol.XCellType.Date, align: XCol.XAlignType.Center,}),
        XCol.Create({ col: 12, text: 'PRO #', width: 120, dataIndex: 'orderNo'}),
       // XCol.Create({ col: 11, text: 'BIL', width: 40, dataIndex: 'billStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 13, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 14, text: 'Create by', width: 80, dataIndex: 'u1ID'}),
        XCol.Create({ col: 15, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 16, text: 'Update by', width: 80, dataIndex: 'u2ID'}),
    ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return BTLocalDOListItem.ExportCollection;
    };

    public static OrderBy = { orderBy: BTLocalDOListItem.prototype.id, orderByAscending: false };

    public static formatData(data: BTLocalDOListItem[]) {
        return data.map((d: BTLocalDOListItem) => ({
            ...d,
        }));
    }

    public static MapSearchFields: { [key: string]: { [key: string]: string } } = {
        doDate: {from: 'fromDoDate', to: 'toDoDate'},
        u1Date: { from: 'fromU1Date', to: 'toU1Date' },
        u2Date: { from: 'fromU2Date', to: 'toU2Date' },
        pickupDate: {from: 'fromPickupDate', to:'toPickupDate'},
    }
}